import React from "react";
import { Quote } from "lucide-react";

// Placeholder quotes from beta users / partners — replace with real customers.
const TESTIMONIALS = [
  {
    quote:
      "Our customers finally see the product in their own room before ordering. Conversations that took days now close in minutes.",
    name: "Beta User",
    role: "Tile Retailer",
  },
  {
    quote:
      "The QR experience in our showroom changed how walk-ins shop. People explore the whole catalog on their own phone.",
    name: "Partner",
    role: "Furniture Showroom",
  },
  {
    quote:
      "Returns dropped noticeably once customers could visualize colors and textures in their actual space.",
    name: "Beta User",
    role: "Paint & Decor Brand",
  },
];

export default function Testimonial() {
  return (
    <section className="bg-white py-16 sm:py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-primary">Testimonials</p>
          <h2 className="mt-3 text-3xl font-bold text-neutral-900 md:text-4xl">
            What early users are saying
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.quote}
              className="flex flex-col rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm shadow-neutral-900/[0.03] sm:p-8"
            >
              <Quote className="h-8 w-8 text-primary/30" />
              <blockquote className="mt-4 flex-1 leading-relaxed text-neutral-600">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-sm font-bold text-primary">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-neutral-900">{t.name}</p>
                  <p className="text-sm text-neutral-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
